import { GridCellProps, GridCustomCellProps } from '@progress/kendo-react-grid';
import { useTranslation } from 'react-i18next';
import useBreakpoints from '../../../../../../common/hooks/useBreakpoints';
import Button from '../../../../../../common/widgets/Button';
import { GridCellTd } from '../../../../../../common/widgets/Grid';
import Icons from '../../../../../../common/widgets/Icons';
import PopoverDialog from '../../../../../../common/widgets/PopoverDialog';
import { resources } from '../../../../resources/resources';

export interface ActionsCellProps extends GridCustomCellProps {
  handleDownloadFile: (uploadId: number, fileName: string) => void;
  handleDeleteFile: (uploadId: number) => void;
  isApproving: boolean;
}

export const ActionsCell = (props: ActionsCellProps) => {
  const { isTablet } = useBreakpoints();
  const { dataItem, isApproving, handleDeleteFile, handleDownloadFile } = props;
  const { t: translate } = useTranslation();

  return (
    <GridCellTd {...props} className="grid-actions-cell">
      {!isTablet ? (
        <span className="grid-actions">
          <button
            className="btn-link grid-action-nav"
            onClick={() => handleDownloadFile(dataItem.uploadId, dataItem.name)}
          >
            <span className="btn-icon">
              <Icons.DownloadFile />
            </span>
            <span className="btn-text">
              {translate(
                resources.timeAndAttendance.files.grid.actions.download,
              )}
            </span>
          </button>

          <button
            className="btn-link grid-action-nav"
            onClick={() => handleDeleteFile(dataItem.uploadId)}
          >
            <span className="btn-icon">
              <Icons.Delete />
            </span>
            <span className="btn-text">
              {translate(resources.timeAndAttendance.files.grid.actions.delete)}
            </span>
          </button>
        </span>
      ) : (
        <PopoverDialog
          className="popover-actions-list"
          placement="bottom"
          closeFromContent
          type="click"
          appendTo={document.body}
          content={
            <>
              <Button
                className="btn"
                onClick={() =>
                  handleDownloadFile(dataItem.uploadId, dataItem.name)
                }
                loading={isApproving}
              >
                {translate(
                  resources.timeAndAttendance.files.grid.actions.download,
                )}
              </Button>

              <button
                className="btn"
                onClick={() => handleDeleteFile(dataItem.uploadId)}
              >
                {translate(
                  resources.timeAndAttendance.files.grid.actions.delete,
                )}
              </button>
            </>
          }
        >
          <a className="mobile-admin-action"></a>
        </PopoverDialog>
      )}
    </GridCellTd>
  );
};

export const fileNameCell = ({ dataItem }: GridCellProps) => (
  <GridCellTd>
    <strong>{dataItem.name}</strong>
  </GridCellTd>
);
